import React, { useContext } from 'react';
import FacetTags from '@cat/inline-facet-tags';
import { PageDataContext } from '../../providers/page-data-provider';
import { NewFacetSelectionType } from '../../../types/facets';
import getStyles from './styles';

const InlineFacetTags = (): JSX.Element => {
  const { facetTags, onFacetChange } = useContext(PageDataContext);

  return (
    <div
      className="inline-facet-tags-container"
      data-testid="inline-facet-tags-container"
      css={getStyles()}
    >
      {/* @ts-ignore */}
      <FacetTags
        facetOptions={facetTags}
        onClear={(option: NewFacetSelectionType) => onFacetChange({ ...option, applied: false })}
      />
    </div>
  );
};

export default InlineFacetTags;
